import Vue from 'vue';
import SvgIcon from '@/components/common/SvgIcon.vue';

// 注册全局组件svg-icon（方便使用svg）
// 在组件svg-icon上传入icon名，即可使用svg图
Vue.component('svg-icon', SvgIcon);

// require.context(directory，useSubdirectories，regExp)
// 其组件目录的相对路径
// 是否查找子目录
// 正则匹配
const req = require.context('./svg', false, /\.svg$/);
const requireAll = (requireContext) => {
    let allIconName = [];
    requireContext.keys().map((ele, idx) => {
        allIconName.push(ele.replace(/^\.\/(.*)\.\w+$/, '$1'));
        requireContext(ele, idx);
    });
    Vue.prototype.$svgIconList = allIconName;
}
requireAll(req);
